export default {
  'ciscospark.container.message.deleteAlert.body': 'Are you sure you want to delete this message?',
  'ciscospark.container.message.deleteAlert.title': 'Delete',
  'ciscospark.container.message.deleteAlert.cancelButton': 'Cancel',
  'ciscospark.container.message.messageComposer.placeholder': 'Send a message to {displayName}',
  'ciscospark.systemMessage.conversation.youCreate': 'You created this conversation.',
  'ciscospark.systemMessage.conversation.someoneCreate': '{name} created this conversation.',
  'ciscospark.systemMessage.message.youDelete': 'You deleted your message.',
  'ciscospark.systemMessage.message.youEdited': 'Edited',
  'ciscospark.systemMessage.message.someoneDelete': '{name} deleted their own message.',
  'ciscospark.datetime.today': 'Today',
  'ciscospark.datetime.yesterday': 'Yesterday',
  'ciscospark.container.message.scrollToBottom': 'Click to scroll to latest messages',
  'ciscospark.container.message.newMessages.message': 'NEW MESSAGES',
  'ciscospark.container.message.dropzone.coverMessage': 'Drag and drop your files here',
  'ciscospark.container.message.sharedCards': '{cardsLength, plural, =1 {Responded with a card} other {Responded with # cards}}',
  'ciscospark.container.message.sharedPhotos': '{imagesLength, plural, =1 {Shared a photo} other {Shared # photos}}',
  'ciscospark.container.message.sending': 'Sending...',
  'ciscospark.container.message.sent': 'Sent',
  'ciscospark.container.message.unableToSendYourRequest': 'Unable to send your request'
};
